<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading {{ $t('pageHeader.calender') }}
      v-spacer
      v-btn(small flat @click="$refs.calendar.prev()" icon)
        v-icon(small) keyboard_arrow_left
      v-btn(small flat @click="$refs.calendar.next()" icon)
        v-icon(small) keyboard_arrow_right
    v-card-text
      v-calendar(ref="calendar" v-model="start" :end="end" :value='today' color='primary')
        template(v-slot:day='{ date }')
          template(v-for='event in eventsMap[date]')
            v-menu(v-model='event.open', full-width, offset-x)
              template(v-slot:activator='{ on }')
               div.ticket-event(v-if="event.type === 'ticket'", v-ripple, v-on='on') {{ event.start | moment("h:m a")}} {{ event.title }}
               div.lead-event(v-else, v-ripple, v-on='on') {{ event.start | moment("h:m A")}} {{ event.title }}
              v-card(color='grey lighten-4', min-width='350px', flat)
                v-toolbar(:color='colorType(event)', dark height="45")
                  v-toolbar-title
                    h1.subheading {{ event.title }}
                  v-spacer
                  v-btn(icon)
                    v-icon close
                v-card-title(primary-title v-if="event.type === 'ticket'")
                  v-layout(column wrap)
                    v-flex
                      div {{ $t('labels.date') }}:
                        span.ml-1.font-weight-medium {{ event.start | moment("MM/DD/YYYY hh:mm A")}}
                    v-flex
                      div {{ $t('labels.name') }}:
                        span.ml-1.font-weight-medium {{ event.data.name }}
                    v-flex
                      div {{ $t('labels.phoneNumber') }}:
                        span.ml-1.font-weight-medium {{ event.data.phoneNumber }}
                    v-flex
                      div {{ $t('labels.title') }}:
                        span.ml-1.font-weight-medium {{ event.detail }}
                    v-flex
                      div.mt-1 {{ $t('labels.description') }}
                        span.ml-1.font-weight-medium {{ event.description }}
                v-card-title(primary-title v-else)
                  v-layout(column wrap)
                    v-flex
                      div {{ $t('labels.date') }}:
                        span.ml-1.font-weight-medium {{ event.start | moment("MM/DD/YYYY hh:mm A")}}
                    v-flex
                      div {{ $t('labels.businessName') }}:
                        span.ml-1.font-weight-medium {{ event.data.businessName }}
                    v-flex
                      div {{ $t('labels.phoneNumber') }}:
                        span.ml-1.font-weight-medium {{ event.data.phoneNumber }}
                    v-flex
                      div {{ $t('labels.email') }}:
                        span.ml-1.font-weight-medium {{ event.data.email }}
                    v-flex
                      div {{ $t('labels.note') }}:
                        span.ml-1.font-weight-medium {{ event.detail }}
                v-card-actions
                  v-btn(color='info' @click="gotoPage(event)") Open
                  v-btn(color="info" flat @click="gotoPageNewTab(event)")
                    v-icon(left) open_in_new 
                    | Open in new tab
</template>

<script>
import HomeService from '../service'
import { mapGetters } from 'vuex';
export default {
  name: 'calendar',
  data: () => ({
    type: 'month',
    start: null,
    end: null,
    today: null,
    ticketEvents: [],
    leadsEvents: [],
    events: [],
  }),
  async created() {
    await this.getTicketEvent(this.currentUser.userID)
    await this.getLeadEvent(this.currentUser.userID)
    this.events = this._.concat(this.ticketEvents, this.leadsEvents)
  },
  computed: {
    ...mapGetters('global', ['currentUser']),
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map
    },
  },
  methods: {
    gotoPageNewTab(data) {
      let routeData = null
      if (data.type === 'ticket'){
        routeData = this.$router.resolve({ path: `/tickets/profile/${data.data.id}`})
      }else {
        routeData = this.$router.resolve({ path: `/leads/profile/${data.data.id}`})
      }
      window.open(routeData.href, '_blank');
    },
    gotoPage(data) {
      if (data.type === 'ticket'){
        this.$router.push({ path: `/tickets/profile/${data.data.id}` })
      }else {
        this.$router.push({ path: `/leads/profile/${data.data.id}` })
      }
    },
    colorType(val) {
      if (val.type === 'ticket') return 'primary'
      else return '#76BF79'
    },
    getTicketEvent(id) {
      return HomeService.getTicketEvent(id)
      .then(result => {
        this.ticketEvents = result.data.events
      })
    },
    getLeadEvent(id) {
      return HomeService.getLeadEvent(id)
      .then(result => {
        this.leadsEvents = result.data.events
      })
    },
    open(event) {
      alert(event.title);
    }
  }
};
</script>

<style scoped>
.ticket-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #fff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.lead-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #76BF79;
  color: #fff;
  border: 1px solid #76BF79;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>
